import {
  DropdownField,
  getPatientPlansField,
  getPregnancyPlan,
  getPregnancyPlansField,
  InsuranceCoverage,
  InsuranceProvider,
  insurersCollection,
  PatientCoverageId,
  PopulatedInsurancePlans,
  PopulatedPregnancyPlans,
  WithId,
} from '@hb/shared'
import { get as nestedGet } from 'nested-property'
import { useMemo } from 'react'
import { useCollection } from '../../collections/hooks/useCollection'
import { InsuranceCoveragePreview } from '../../components/Assessments/Coverage/InsuranceCoveragePreview'

const RenderPlanOption = ({
  plan,
  allInsuranceProviders,
}: {
  plan: InsuranceCoverage | null
  allInsuranceProviders: WithId<InsuranceProvider>[]
}) => <InsuranceCoveragePreview plan={plan} allInsuranceProviders={allInsuranceProviders} />

export const usePatientPlanField = (
  plans: PopulatedInsurancePlans | undefined,
  modifier?: (f: DropdownField) => DropdownField,
) => {
  const { items: insuranceProviders } = useCollection(insurersCollection)
  return useMemo(() => {
    const baseField: DropdownField = {
      ...getPatientPlansField(plans),
      renderOption: option => (
        <RenderPlanOption
          plan={nestedGet(plans, option.id as PatientCoverageId)}
          allInsuranceProviders={insuranceProviders}
        />
      ),
    }
    return modifier ? modifier(baseField) : baseField
  }, [plans, insuranceProviders, modifier])
}

export const usePregnancyPlanField = (
  plans: PopulatedPregnancyPlans | undefined,
  modifier?: (f: DropdownField) => DropdownField,
) => {
  const { items: insuranceProviders } = useCollection(insurersCollection)
  return useMemo(() => {
    const baseField: DropdownField = {
      ...getPregnancyPlansField(plans),
      renderOption: option => (
        <RenderPlanOption
          plan={getPregnancyPlan(plans, option.id as PatientCoverageId)}
          allInsuranceProviders={insuranceProviders}
        />
      ),
    }
    return modifier ? modifier(baseField) : baseField
  }, [plans, insuranceProviders, modifier])
}
